import { render, staticRenderFns } from "./Suboption.vue?vue&type=template&id=02b2d294&scoped=true&"
import script from "./Suboption.vue?vue&type=script&lang=js&"
export * from "./Suboption.vue?vue&type=script&lang=js&"
import style0 from "./Suboption.vue?vue&type=style&index=0&id=02b2d294&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b2d294",
  null
  
)

export default component.exports